import { PatientScheduleSkeleton } from 'features/Home/Book/Booking/Schedule/PatientSchedule/PatientScheduleSkeleton/PatientScheduleSkeleton'
import { type ReactNode, useEffect, useRef, useState } from 'react'
import styles from './staffSchedulePane.module.scss'

type StaffSchedulePaneProps = {
  name: string
  eager?: boolean
  layout?: 'stack' | 'row'
  children: ReactNode
}

export const StaffSchedulePane = ({
  name,
  eager = false,
  layout = 'stack',
  children,
}: StaffSchedulePaneProps) => {
  const [shouldRender, setShouldRender] = useState(eager)
  const paneRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (shouldRender) return
    const node = paneRef.current
    if (!node) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setShouldRender(true)
      },
      { rootMargin: layout === 'row' ? '0px 50%' : '50% 0px' },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [layout, shouldRender])

  return (
    <section
      ref={paneRef}
      className={layout === 'row' ? `${styles.pane} ${styles.paneRow}` : `${styles.pane} ${styles.paneStack}`}>
      <h2 className={styles.title}>{name}</h2>
      {shouldRender ? children : <PatientScheduleSkeleton />}
    </section>
  )
}
